import { useState } from "react"

import { useMutation } from "@tanstack/react-query"
import { Loader } from "lucide-react"
import { toast } from "sonner"

import { Button } from "@/components/ui/button.tsx"
import { Input } from "@/components/ui/input.tsx"
import { Label } from "@/components/ui/label.tsx"

import { importKPIValues } from "../api/importKPIValues.ts"

import type { CSVImporterConfig } from "../types/csvImporterTypes.ts"

export default function CSVImporter({ config }: { config: CSVImporterConfig }) {
  const [file, setFile] = useState<File | null>(null)
  const mutation = useMutation({
    mutationFn: (file: File) => importKPIValues(file, config.endpoint),
    onMutate: () => toast("Importing"),
    onSuccess: () => toast("Import Successful"),
    onError: () => toast("Import Error"),
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0])
    }
  }

  const handleUpload = () => {
    if (file != null) {
      mutation.mutate(file)
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <Label>{config.label}</Label>
      {mutation.isPending ? (
        <div className="h-[26px] text-muted-foreground font-semibold flex gap-2">
          Importing
          <Loader className="animate-spin" />
        </div>
      ) : (
        <div className="flex gap-2">
          <Input type="file" accept=".csv" onChange={handleChange} />
          <Button variant="default" disabled={file == null} onClick={handleUpload}>
            Upload
          </Button>
        </div>
      )}
    </div>
  )
}
